import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.Toolbar', {
    syncNow: 'Sync now',
    settings: 'Settings',
    showActionMenu: 'Show action menu',
    disableBudgetSyncWithXero: 'Disable budget sync with Xero',
    syncBudgetsWithXero: 'Sync budgets with Xero',
    uploadNewBudget: 'Upload new budget',
});
